/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import MealNutrition from './meal-nutrition';
import MealNutritionDetail from './meal-nutrition-detail';
import MealNutritionUpdate from './meal-nutrition-update';
import MealNutritionDeleteDialog from './meal-nutrition-delete-dialog';

const MealNutritionRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<MealNutrition />} />
    <Route path="new" element={<MealNutritionUpdate />} />
    <Route path=":id">
      <Route index element={<MealNutritionDetail />} />
      <Route path="edit" element={<MealNutritionUpdate />} />
      <Route path="delete" element={<MealNutritionDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default MealNutritionRoutes;
